
import { ResultsDTO } from "Types";
import { PickupLocationSettingDTO } from "Interface";
import { ApiService } from "../ApiService";

export const ShipmentConfigApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        savePickupLocation: builder.mutation<ResultsDTO, PickupLocationSettingDTO>({
            query: (pickupLocationSettingDTO) => ({
                url: `/admin/pickup-location-config/create`,
                method: 'POST',
                body: { ...pickupLocationSettingDTO }
            })
        }),
        getPickupLocations: builder.query<PickupLocationSettingDTO[], void>({
            query: () => ({
                url: `/admin/pickup-location-config/`,
                method: 'GET'
            }),
            transformResponse: (res: ResultsDTO<PickupLocationSettingDTO[]>) => res.results ?? [],
        }),
    })
});

export const { useGetPickupLocationsQuery, useSavePickupLocationMutation } = ShipmentConfigApiSlice;
